//Load cart object data
    function cartProcess() {
    theme.cart.getCart().then((cartData => {
      const freeShipEnabled = true;
      const upsellEnabled = true;
      
      if (freeShipEnabled){
        freeShipping(cartData);
      }

      if (upsellEnabled){
        cartSkus(cartData);
      };
      
    }))
  }
  
  //Listen for 'cart build'
   document.addEventListener('cart:updated', function(evt){
     cartProcess();
  });
  
  //Listen for 'cart build'
   document.addEventListener('ajaxProduct:added', function(evt){
     cartProcess();
  });
  
  //Listen for 'cart build'
   document.addEventListener('DOMContentLoaded', function(evt){
    cartProcess();
  });

  //Listen for 'cart build'
   document.addEventListener('cart:build', function(evt){
    cartProcess();
    });
  
  //Cart Free Shipping Script

  // Update free gift progress bar + free gift messaging
  // Update for Ajax drawer cart
  // Ensure subscription variantId is passed to cart
 function freeShipping(data){
    let cartTotal = data.total_price;
    let cartitems = data.items;
    let subscriptionplan = cartitems.filter(element => element.selling_plan_allocation);
    let freeshippingamount = 40 * 100;
    let fselement = document.getElementById("shipping-text");
    let shiptotal = document.getElementById("shippingcost");
    let progressbar = document.querySelector(".ship_progressbar");
    let shipcontainer = document.getElementById("free-shipping-container");
    
    if (freeshippingamount < cartTotal || subscriptionplan.length != 0){
      fselement.innerHTML = "You scored <b>Free Shipping!</b>";
      shiptotal.innerHTML = "FREE";
      progressbar.style.width = 100 + "%";
      progressbar.style.backgroundColor = "#53c563";
    } else {
      let pricediff = ((freeshippingamount - cartTotal)/100).toFixed(2);
      let variance = (cartTotal/freeshippingamount) * 100;
      fselement.innerHTML = "You're " + "€" + pricediff + " away from <b>Free EU Shipping</b>";
      shiptotal.innerHTML = "€12,50";
      progressbar.style.width = variance + "%";
      progressbar.style.backgroundColor = "#d22137";
    }
  }
 
  // Hide elements based on cart contents - upsell
  function cartSkus(data){
    const upsellEnabled = true;
    let upsellcontainer = document.getElementById("upsell-container");
    let cartTotal = data.total_price;
    let cartitems = data.items;
    let cartskus = cartitems.map(element => element.sku);
    let upsellskus = ['4385'];
    
    function checkContents(arr1, arr2){
    	return arr1.some(item => arr2.includes(item))
    }
    
  if(checkContents(cartskus, upsellskus)){
      upsellcontainer.classList.add("hide");
      console.log(cartitems);
    } else {
      upsellcontainer.classList.remove("hide");
    }
  }
  
  // Add to cart button
	function addToCart(variant, freeGiftClass) {
    fetch('/cart/add.js', {
        body: JSON.stringify({
            'id': variant, 
            'quantity': 1
        }),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    }).then(function (response) {
        return response.json();
    }).then(function (json) {
      
    document.dispatchEvent(new CustomEvent('cart:build'));

    }).catch(function (err) {
        console.error(err)
    });
	}